/**
 * DevExtreme (esm/renovation/ui/scheduler/workspaces/const.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var DefaultSizes = {
    allDayPanelHeight: 25
};
export var DATE_TABLE_CELL_CLASS = "dx-scheduler-date-table-cell";
export var ALL_DAY_PANEL_CELL_CLASS = "dx-scheduler-all-day-table-cell";
export var DATE_TABLE_ROW_CLASS = "dx-scheduler-date-table-row";
export var ALL_DAY_ROW_CLASS = "dx-scheduler-all-day-table-row";
